let isTestEnvironment = false;
export const setIsTestEnvironment = (value: boolean) => {
	isTestEnvironment = value;
};

type Cb = () => void;
const autoBeforeEachActions: Cb[] = [];

/**
 * Schedules an action to be performed in the beforeEach of every test
 */
export const autoBeforeEachTest = (fn: Cb): void => {
	if (isTestEnvironment) {
		autoBeforeEachActions.push(fn);
	}
};

/**
 * Exections actions to be done in the beforeEach of every test
 */
export const executeAutoBeforeEachTestActions = (): void => {
	autoBeforeEachActions.forEach((action) => action());
};
